import './bml-nomenclature.scss';

const NOMENCLATURE_HTML = `<h2 class="nomenclature-section-header">ПАТОЛОГОГІСТОЛОГІЧНІ ДОСЛІДЖЕННЯ</h2>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДЕРМАТОЛОГІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H003</td><td>ІІ категорія складності
Інцизійна, панч та радіохвильова біопсія шкіри при доброякісних пухлинних та пухлиноподібних процесах  - до 3 утворень включно

Нозології: папілома, м’яка фіброма, фіброепітеліальний поліп, кератопапілома, бородавка, кісти, атерома, контагіозний молюск, себорейний кератоз,  акрохордон, піогенна гранульома, невуси - епідермальний, сальних залоз, волосяного фолікула та інші</td><td>5 днів</td></tr>
      <tr><td>H004</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H005</td><td>III категорія складності 
Ексцизійна біопсія пухлин шкіри з оцінкою країв резекції - за 1 локалізацію

Нозології: усі види меланоцитарних невусів, актинічний кератоз, еритроплазія Кейра, дерматофіброма, нейролемома, ангіофіброма, порома, сирингоаденома, гідроаденома, трихолемома, лейоміома, доброякісні пухлини сполучної тканини, меланома, лентіго малігна, плоскоклітинна карцинома, кератоакантома, рак Педжета, інтраепітеліальний рак Боуена, рак потових та сальних залоз, ангіоперицитома, дерматофібросаркома, базальноклітинна карцинома, саркоми та інші</td><td>5 днів</td></tr>
      <tr><td>H006</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H007</td><td>IV категорія складності 
Панч-біопсії або інші види біопсії шкіри при запальних дерматозах та алопеціях, видалення нігтьового ложа</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ГАСТРОЕНТЕРОЛОГІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H009</td><td>ІІ категорія складності (біопсії утворень черевної порожнини і позаочеревинного простору, апендиктоміїї та дивертикулектомії при запальних процесах, видалення жовчного міхура при запальних процесах, видалення гемороїдальних вузлів та анальних тріщин, видалення куприкових кіст та нориць, герніопластика (видалення грижових мішків та ін.)</td><td>5 днів</td></tr>
      <tr><td>H010</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H011</td><td>III категорія складності (біопсії шлунка - до 5 біоптатів включно, біопсії стравоходу - до 3 біоптатів включно, біопсії підшлункової залози, біопсії печінки, біопсії тонкої та/або товстої кишки - до 6 біоптатів включно, біопсії 12-ти палої кишки - до 6 біоптатів включно та та ін.)</td><td>5 днів</td></tr>
      <tr><td>H012</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H013</td><td>IV категорія складності (спленектомії, видалення жовчного міхура при пухлинних процесах, ексцизійні біопсії (поліпектомії) поліпів органів ШКТ - до 5 утворень включно, біопсії шлунка з оцінкою за Сіднейською системою, системами OLGA та OLGIM, резекція шлунку при ожирінні та ін.)</td><td>5 днів</td></tr>
      <tr><td>H014</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H015</td><td>V категорія складності (видалення підшлункової залози (субтотальні і радикальні резекції), гастректомії, субтотальні резекції шлунка, резекції стравоходу, геміколектомії, есктирпації прямої кишки та інші резекції кишки, панкреато-дуоденальної резекції, резекції печінки та гемігепатектомії, резекції слизової оболонки та ендоскопічні підслизові дисекції (EMR, ESD) та ін.)</td><td>5 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ГІНЕКОЛОГІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H016</td><td>ІІ категорія складності (біопсії шийки матки (не ексцизійні), біопсії піхви, біопсії ендометрію (аспіраційні біопсії, вишкрібання, поліпектомії), вишкрібання цервікального каналу, видалення кіст бартолінової залози та ін.)</td><td>5 днів</td></tr>
      <tr><td>H017</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H020</td><td>III категорія складності (дослідження абортивного матеріалу (до 12 тижнів), ексцизії та конізації шийки матки, біопсії клиноподібної резекції яєчнику (з одного боку), міомектомія, видалення паратубарної (гідатиди), параоваріальної кісти і кісти яєчника (з одного боку) та ін.</td><td>5 днів</td></tr>
      <tr><td>H021</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H022</td><td>IV категорія складності (видалення придатків матки при пухлинах яєчника (з одного боку), дослідження плаценти, дослідження плідних оболонок (при одноплідній вагітності, з 12 тижнів), трахелектомії і видалення кукси шийки матки, видалення матки без придатків та ін.)</td><td>5 днів</td></tr>
      <tr><td>H023</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H024</td><td>V категорія складності (видалення матки з придатками, тотальні вульвектомії, дослідження плідних оболонок діхоріонічних близнюків та ін.)</td><td>5 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ЕНДОКРИНОЛОГІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H025</td><td>ІІ категорія складності Лімфодисекція шиї центральна (при карциномах, при підозрі на карциному, зі збільшенням лімфовузлів та ін. у діагностичних цілях) - за одну групу лімфовузлів</td><td>7 днів</td></tr>
      <tr><td>H026</td><td>ІІ категорія складності Лімфодисекція шиї бічна одностороння/двостороння (при карциномах щитовидної залози з можливим метастатичним ураженням регіонарних лімфовузлів шиї та ін.) - за одну групу лімфовузлів</td><td>7 днів</td></tr>
      <tr><td>H029</td><td>ІІІ категорія складності Видалення паращитовидної залози (гіперпаратиреоз, аденома паращитовидної залози та ін.)</td><td>7 днів</td></tr>
      <tr><td>H027</td><td>V категорія складності Тиреоїдектомія (повне видалення щитовидної залози - включає 2 частки і перешийок), карцинома щитовидної залози, дифузний токсичний зоб, багатовузловий зоб та ін.)</td><td>7 днів</td></tr>
      <tr><td>H028</td><td>V категорія складності Гемітиреоїдектомія, видалення однієї частки (наявність доброякісного/умовно доброякісного утворення  в одній частині залози, фолікулярна неоплазія, підозра на карциному, мікрокарцинома та ін. - до 5 мм, вузол/ вузли в одній частці)</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">МАМОЛОГІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H018</td><td>ІІ категорія складності (трепан-біопсії молочної залози (з одного боку)</td><td>5 днів</td></tr>
      <tr><td>H019</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H061</td><td>III категорія складності (резекції грудної залози при гінекомастії, маститах та ін.)</td><td>5 днів</td></tr>
      <tr><td>H062</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H063</td><td>IV категорія складності (секторальної резекції, квадрантектомії та лампектомії грудної залози)</td><td>5 днів</td></tr>
      <tr><td>H064</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H065</td><td>V категорія складності (радикальні резекції грудної залози та мастектомії (з одного боку)</td><td>5 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ОТОЛАРІНГОЛОГІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H030</td><td>І категорія складності (біопсії слизових оболонок ротової порожнини, порожнини та пазух носа, гортані та ін.)</td><td>5 днів</td></tr>
      <tr><td>H031</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H032</td><td>ІІ категорія складності (септопластики, біопсії мигдалика (з одного боку), біопсії слинної залози (з одного боку), видалення епулідів, одонтогенних кіст, травматичних фібром слизової оболонки, видалення поліпів та кіст порожнини носа та пазух та ін.)</td><td>5 днів</td></tr>
      <tr><td>H033</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H034</td><td>III категорія складності (видалення кіст шиї, мигдаликів та ін.)</td><td>5 днів</td></tr>
      <tr><td>H035</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H036</td><td>IV категорія складності (видалення слинної залози (з одного боку), видалення пухлин ротової та носової порожнини та ін.)</td><td>5 днів</td></tr>
      <tr><td>H037</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H038</td><td>V категорія складності (тотальна ларингектомія та резекції гортані, резекція носової перегородки при пухлинній патології, глоссектомія (видалення язика), радикальна паротидектомія та ін.)</td><td>5 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ОФТАЛЬМОЛОГІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H068</td><td>ІІ категорія складності (видалення сльозових залоз, операційний матеріал повік, кон&#x27;юктиви та ін.)</td><td>5 днів</td></tr>
      <tr><td>H069</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H070</td><td>IV категорія складності (видалення очного яблука)</td><td>5 днів</td></tr>
      <tr><td>H071</td><td>(терміново)</td><td>2 дні</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ПУЛЬМОНОЛОГІЯ ТА ТОРАКАЛЬНА ХІРУРГІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H072</td><td>III категорія складності (біопсії бронхів, легень (за одну локалізацію), біопсії плеври, трепан-біопсії середостіння, біопсії лімфовузлів середостіння та ін.)</td><td>5 днів</td></tr>
      <tr><td>H073</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H074</td><td>IV категорія складності (видалення пухлин середостіння, резекція / атипова резекція легені та ін.)</td><td>5 днів</td></tr>
      <tr><td>H075</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H076</td><td>V категорія складності (лобектомії та пульмонектомії та ін.)</td><td>5 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">УРОЛОГІЯ ТА НЕФРОЛОГІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H039</td><td>І категорія складності (біопсії сечоводу (з одного боку), біопсії сечового міхура, біопсії уретри та ін.)</td><td>5 днів</td></tr>
      <tr><td>H040</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H041</td><td>ІІ категорія складності (видалення оболонок яєчка і кіст додатку яєчка, біопсії нирки (новоутворень) (з одного боку), біопсії наднирника (з одного боку) та ін.)</td><td>5 днів</td></tr>
      <tr><td>H042</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H043</td><td>III категорія складності (поліфокальні трепан-біопсії передміхурової залози, циркумцизіо (видалення крайньої плоті) та ін.</td><td>5 днів</td></tr>
      <tr><td>H044</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H045</td><td>IV категорія складності (трансуретральна резекція простати, сечового міхура, видалення яєчка та придатків (з одного боку), резекції сечового міхура, резекції нирки, адреналектомії та ін.)</td><td>5 днів</td></tr>
      <tr><td>H046</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H047</td><td>V категорія складності (радикальна простатектомія, цистектомія, нефректомія  та ін. (в тому числі з адреналектомією)</td><td>5 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ХІРУРГІЯ ТА ІНШЕ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H077</td><td>І категорія складності (лімфодисекція  та ін.)</td><td>5 днів</td></tr>
      <tr><td>H078</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H048</td><td>ІІ категорія складності (видалення судин, видалення міжхребцевих дисків  та ін.)</td><td>5 днів</td></tr>
      <tr><td>H049</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H050</td><td>III категорія складності (трепан-біопсії лімфовузлів (за 1 локалізацію), видалення синовіальних оболонок (гангліон і бурс) та кіст сухожилля, біопсії головного і спинного мозку та їх оболонок, резекції кістки при артропатіях  та ін.)</td><td>5 днів</td></tr>
      <tr><td>H051</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H052</td><td>IV категорія складності (ексцизійні біопсії лімфатичних вузлів, видалення пухлин головного та спинного мозку та їх оболонок, видалення одонтогенних пухлин, пухлин кісток черепа, ламінектомії  та ін.)</td><td>5 днів</td></tr>
      <tr><td>H053</td><td>(терміново)</td><td>2 дні</td></tr>
      <tr><td>H054</td><td>V категорія складності (видалення пухлин кісток та суглобів, резекції кістки при пухлинній патології  та ін.)</td><td>5 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ЕКСПРЕС ПАТОЛОГОГІСТОЛОГІЧНІ ДОСЛІДЖЕННЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>HED001</td><td>Інтраопераційне патологогістологічне дослідження – за перший етап.</td><td>60 хвилин**</td></tr>
      <tr><td>HED001/1</td><td>Патогістологічне дослідження фіксованого препарату після інтраопераційного дослідження</td><td>5 днів</td></tr>
      <tr><td>HED002</td><td>Інтраопераційне патологогістологічне дослідження – за другий та кожний подальший етап</td><td>60 хвилин**</td></tr>
      <tr><td>HED005</td><td>Інтраопераційне патологогістологічне дослідження. Час реєстрації дослідження після 17:00 (за кожен етап)</td><td>60 хвилин**</td></tr>
      <tr><td>HED005/1</td><td>Патогістологічне дослідження фіксованого препарату після інтраопераційного дослідження</td><td>5 днів</td></tr>
      <tr><td>HED003</td><td>Мікрографічна хірургія Mohs (за перший етап)</td><td>60 хвилин**</td></tr>
      <tr><td>HED004</td><td>Мікрографічна хірургія Mohs (за другий та подальші етапи, за кожний)</td><td>60 хвилин**</td></tr>
      <tr><td>HED006</td><td>Мікрографічна хірургія Mohs. Час реєстрації дослідження після 17:00 (за кожен етап)</td><td>60 хвилин**</td></tr>
      <tr><td>HED007</td><td>Мікрографічна хірургія Slow Mohs (за перший етап)</td><td>4 дні</td></tr>
      <tr><td>HED008</td><td>Мікрографічна хірургія Slow Mohs (за другий та подальші етапи, за кожний)</td><td>3 дні</td></tr>
      <tr><td>HED009</td><td>Мікрографічна хірургія &quot;en face’’ (за перший етап). Дослідження замороженого зрізу &quot;en face’’</td><td>60 хвилин**</td></tr>
      <tr><td>HED009/1</td><td>Мікрографічна хірургія &quot;en face’’ (за перший етап). Патогістологічне дослідження фіксованого препарату</td><td>4 дні</td></tr>
      <tr><td>HED010</td><td>Мікрографічна хірургія &quot;en face’’ (за другий та подальші етапи, за кожний). Дослідження замороженого зрізу &quot;en face’’</td><td>60 хвилин**</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОНСУЛЬТАЦІЇ ПАТОГІСТОЛОГІЧНОГО МАТЕРІАЛУ ТА ДОДАТКОВІ ПОСЛУГИ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>H055</td><td>Консультація патогістологічного матеріалу (друга думка/second opinion) за 1 матеріал</td><td>5 днів</td></tr>
      <tr><td>H056</td><td>(терміново)</td><td>24 години</td></tr>
      <tr><td>H057</td><td>Патологогістологічний висновок іноземного лікаря-патолога з переглядом сканованого препарату (з перекладом)</td><td>12 днів</td></tr>
      <tr><td>H058</td><td>Підготовка патологогістологічного висновку на англійській мові (додатково до ціни дослідження)</td><td>3 дні</td></tr>
      <tr><td>H059</td><td>Додаткове виготовлення гістологічного препарату - парафінового блоку і скельця (за один препарат)</td><td>2 дні</td></tr>
      <tr><td>H060</td><td>Виготовлення цифрового гістологічного препарату - високоточне сканування скельця для перегляду лікарями-патологами (за одне скельце)</td><td>24 години</td></tr>
      <tr><td>Н079</td><td>Визначення Helicobacter Pylori (гістохімічний метод)</td><td>5 днів</td></tr>
      <tr><td>H080</td><td>Оцінка придатності матеріалу для імуногістохімічних та молекулярних досліджень</td><td>2 дні</td></tr>
      <tr><td>H082</td><td>Додаткове гістохімічне забарвлення (за 1 маркер)</td><td>5 днів</td></tr>
      <tr><td>H083</td><td>Консультація гістологічного матеріалу для наукових досліджень (за 1 матеріал)</td><td>5 днів</td></tr>
      <tr><td>H084</td><td>Морфометричне (кількісне) дослідження (за 1 показник)</td><td>5 днів</td></tr>
    </tbody>
  </table>
</div>

<h2 class="nomenclature-section-header">ІМУНОГІСТОХІМІЧНІ ДОСЛІДЖЕННЯ (ІГХ)</h2>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДІАГНОСТИЧНІ ТА ПРОГНОСТИЧНІ ІМУНОГІСТОХІМІЧНІ (ІГХ) ДОСЛІДЖЕННЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>ICH001</td><td>Молекулярний тип раку грудної залози (ER, PR, HER-2/neu,Ki-67)</td><td>5 днів</td></tr>
      <tr><td>ICH002</td><td>Утворення/пухлини щитовидної залози</td><td>10 днів</td></tr>
      <tr><td>ICH003</td><td>Визначення органного походження метастазів карцином невизначеного походження (в будь-який орган) (окрім мезенхімальних пухлин та лімфом)</td><td>10 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ІНШІ ІМУНОГІСТОХІМІЧНІ ДОСЛІДЖЕННЯ (ІГХ)</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>ICH006</td><td>ІГХ визначення білків репарації помилок компліментарності ДНК
(мікросателітна стабільність/нестабільність пухлини)</td><td>5 днів</td></tr>
      <tr><td>ICH007</td><td>ІГХ (p16) визначення HPV-асоційованої патології</td><td>5 днів</td></tr>
      <tr><td>ICH008</td><td>ІГХ (CD138) верифікація хронічного ендометриту</td><td>5 днів</td></tr>
      <tr><td>ICH009</td><td>ІГХ (ER, PR) дослідження гормонального статусу едометрію</td><td>5 днів</td></tr>
      <tr><td>ICH010</td><td>ІГХ (p16, Ki-67) верифікація HSIL</td><td>5 днів</td></tr>
      <tr><td>ICH011</td><td>ІГХ (p57, Ki-67) верифікація міхуревого занеску</td><td>5 днів</td></tr>
      <tr><td>ICH012</td><td>ІГХ дослідження кількості uNK клітин (CD 56) в ендометрії</td><td>5 днів</td></tr>
      <tr><td>ICH013</td><td>ІГХ (PD-L1) визначення чутливості до імунотерапії</td><td>5 днів</td></tr>
      <tr><td>ICH014</td><td>ІГХ визначення експресії р53</td><td>5 днів</td></tr>
      <tr><td>ICH015</td><td>ІГХ визначення експресії Ki-67</td><td>5 днів</td></tr>
      <tr><td>ICH016</td><td>ІГХ дослідження за 1 маркер</td><td>5 днів</td></tr>
      <tr><td>ICH017</td><td>ІГХ визначення експресії PRAME</td><td>5 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h2 class="nomenclature-section-header">БІОХІМІЧНІ ДОСЛІДЖЕННЯ</h2>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>BH001</td><td>Визначення вмісту мікроелементів у волоссі мас-спектрометричним методом</td><td>4 дні</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h2 class="nomenclature-section-header">МОЛЕКУЛЯРНО - ГЕНЕТИЧНІ ДОСЛІДЖЕННЯ В ОНКОГЕМАТОЛОГІЇ</h2>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>MG006</td><td>Кількісна ПЛР BCR‐ABL (р210)</td><td>7 днів</td></tr>
      <tr><td>MG007</td><td>Кількісна ПЛР BCR‐ABL (р190)</td><td>7 днів</td></tr>
      <tr><td>MG008</td><td>Панель 8 транскриптів BCR‐ABL</td><td>10 днів</td></tr>
      <tr><td>MG009</td><td>Визначення мутацій, делецій, інсерцій в гені CALR</td><td>7 днів</td></tr>
      <tr><td>MG010</td><td>Визначення мутацій, делецій в гені MPL</td><td>7 днів</td></tr>
      <tr><td>MG011</td><td>Визначення мутацій в гені FLT3</td><td>7 днів</td></tr>
      <tr><td>MG012</td><td>Визначення мутації JAK2</td><td>7 днів</td></tr>
      <tr><td>MG013</td><td>ХЛЛ панель (визначення мутаційного статусу IGHV – гени B2M,
 HPRT1, LPL, ZAP70, COBLL1, CD3D)</td><td>10 днів</td></tr>
    </tbody>
  </table>
</div>

<h2 class="nomenclature-section-header">ЦИТО-ГЕНЕТИЧНІ ДОСЛІДЖЕННЯ</h2>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДІАГНОСТИКА СОЛІДНИХ ПУХЛИН</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F001</td><td>Визначення ампліфікації гену HER-2/neu (синонім: ампліфікація гену ErbB2) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F002</td><td>Визначення перебудов гену ALK методом FISH</td><td>7 днів</td></tr>
      <tr><td>F003</td><td>Визначення перебудов гену EWSR1 методом FISH</td><td>7 днів</td></tr>
      <tr><td>F004</td><td>Визначення перебудов гену FOXO1 (синоніми: перебудови 13q14, перебудови гену FKH1 перебудови гену FKHR методом FISH</td><td>7 днів</td></tr>
      <tr><td>F005</td><td>Визначення делеції хромосоми 1р36 методом FISH</td><td>7 днів</td></tr>
      <tr><td>F006</td><td>Визначення делеції хромосоми 19q13 методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОМПЛЕКСНА ПРОПОЗИЦІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F007</td><td>Визначення делеції хромосоми 1р36 та делеції хромосоми 19q13 (синонім: ко-делеція 1p36/19q13) методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДІАГНОСТИКА ЛІМФОМ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F008</td><td>Визначення перебудов гену MYC методом FISH</td><td>7 днів</td></tr>
      <tr><td>F009</td><td>Визначення перебудов гену BCL2 методом FISH</td><td>7 днів</td></tr>
      <tr><td>F010</td><td>Визначення перебудов гену BCL6 методом FISH</td><td>7 днів</td></tr>
      <tr><td>F011</td><td>Визначення перебудов гену ALK методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОМПЛЕКСНА ПРОПОЗИЦІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F012</td><td>Визначення перебудов гену MYC, гену BCL2 та гену BCL6 методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДІАГНОСТИКА ХРОНІЧНОГО ЛІМФОЛЕЙКОЗУ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F013</td><td>Визначення делеції хромосоми 17р (синоніми: делеція 17p13.1, делеція гену P53) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F014</td><td>Визначення делеції хромосоми 13q в регіоні 13q14.2 (синоніми: делеція 13q14.2 , делеція гену RB1) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F015</td><td>Визначення делеції хромосоми 13q в регіоні 13q14.3 (синоніми: делеція 13q14.3 , делеція D13S319) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F016</td><td>Визначення делеції хромосоми 11q (синоніми: делеція 11q22.3, делеція гену ATM) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F017</td><td>Визначення трисомії хромосоми 12 (синоніми: +12, кількісні зміни хромосоми 12) методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОМПЛЕКСНІ ПРОПОЗИЦІЇ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F018</td><td>Визначення делеції хромосоми 13q в регіоні 13q14.3 (делеція D13S319) та делеції хромосоми 11q (делеція гену ATM), методом FISH</td><td>7 днів</td></tr>
      <tr><td>F019</td><td>Визначення делеції хромосоми 17р (делеція гену P53), делеції хромосоми 13q в регіоні 13q14.3 (делеція D13S319) та делеції хромосоми 11q (делеція гену ATM), методом FISH</td><td>7 днів</td></tr>
      <tr><td>F020</td><td>Визначення делеції хромосоми 17р (делеція гену P53), делеції хромосоми 13q в регіоні 13q14.3 (делеція D13S319), делеції хромосоми 11q (делеція гену ATM) та трисомії хромосоми 12 (+12), методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДІАГНОСТИКА МІЄЛОМНОЇ ХВОРОБИ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F021</td><td>Визначення перебудов гену IGH методом FISH</td><td>7 днів</td></tr>
      <tr><td>F022</td><td>Визначення аномалій 1q21 (синоніми: дуплікація 1q21, ампліфікація 1q21, аномалії гену CKS1B) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F023</td><td>Визначення делеції хромосоми 17р (синоніми: делеція 17p13.1, делеція гену P53) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F024</td><td>Визначення транcлокації t(4;14) (синонім: транслокація IGH/FGFR3) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F025</td><td>Визначення транcлокації t(11;14) (синонім: транслокація CCND1/IGH) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F026</td><td>Визначення транcлокації t(14;16) (синонім: транслокація IGH/MAF) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F027</td><td>Визначення транcлокації t(14;20) (синонім: транслокація IGH/MAFB) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F028</td><td>Визначення делеції хромосоми 13q в регіоні 13q14.3 (синоніми: делеція 13q14.3 , делеція D13S319) методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОМПЛЕКСНІ ПРОПОЗИЦІЇ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F029</td><td>Визначення перебудов гену IGH, аномалій 1q21 та делеції хромосоми 17р (делеції гену P53) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F030</td><td>Визначення транcлокації t(4;14)(транcлокація IGH/FGFR3), транcлокації t(11;14) (транслокація CCND1/IGH), транcлокації t(14;16) (транслокація IGH/MAF) та транcлокації t(14;20) (транслокація IGH/MAFB) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F031</td><td>Визначення транcлокації t(4;14) (транcлокація IGH/FGFR3), транcлокації t(11;14) (транслокація CCND1/IGH), транcлокації t(14;16) (транслокація IGH/MAF) та транcлокації t(14;20) (транслокація IGH/MAFB), аномалій 1q21 (дуплікація 1q21, ампліфікація 1q21, аномалії гену CKS1B) методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДІАГНОСТИКА ХРОНІЧНИХ МІЄЛОПРОЛІФЕРАТИВНИХ ЗАХВОРЮВАНЬ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F032</td><td>Визначення транcлокації t(9;22) (синонім: транслокація BCR/ABL) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F033</td><td>Визначення перебудов гену PDGFRA (синоніми: злиття генів FIP1L1 та PDGFRA, делеція гену CHIC2) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F034</td><td>Визначення перебудов гену PDGFRB методом FISH</td><td>7 днів</td></tr>
      <tr><td>F035</td><td>Визначення перебудов гену FGFR1 методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОМПЛЕКСНА ПРОПОЗИЦІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F036</td><td>Визначення перебудов генів PDGFRA, PDGFRB та FGFR1 методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДІАГНОСТИКА ГОСТРОЇ МІЄЛОЇДНОЇ ЛЕЙКЕМІЇ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F037</td><td>Визначення транcлокації t(8;21) (синоніми: транслокація AML1/ETO, транслокація RUNX1/RUNX1T1) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F038</td><td>Визначення транcлокації t(15;17) (синонім: транслокація PML/RARA) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F039</td><td>Визначення транcлокації t(16;16) або інверсії inv(16) (синонім: перебудови гену CBFB) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F040</td><td>Визначення транcлокації t(9;22) (синонім: транслокація BCR/ABL) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F041</td><td>Визначення перебудов 11q23 (синоніми: перебудови гену KMT2A, перебудови гену MLL) методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОМПЛЕКСНІ ПРОПОЗИЦІЇ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F042</td><td>Визначення транcлокації t(8;21)(транслокація AML1/ETO), транcлокації t(15;17)(транслокація PML/RARA) та транcлокації t(16;16) або інверсії inv(16)(перебудови гену CBFB) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F043</td><td>Визначення транcлокації t(8;21)(транслокація AML1/ETO), транcлокації t(15;17)(транслокація PML/RARA), транcлокації t(16;16) або інверсії inv(16)(перебудови гену CBFB) та транcлокації t(9;22 (транслокація BCR/ABL) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F044</td><td>Визначення транcлокації t(8;21)(транслокація AML1/ETO), транcлокації t(15;17)(транслокація PML/RARA), транcлокації t(16;16) або інверсії inv(16)(перебудови гену CBFB), транcлокації t(9;22 (транслокація BCR/ABL) та перебудов 11q23 методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДІАГНОСТИКА ГОСТРОЇ ЛІМФОБЛАСТНОЇ ЛЕЙКЕМІЇ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F045</td><td>Визначення транcлокації t(9;22) (синонім: транслокація BCR/ABL) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F046</td><td>Визначення перебудов 11q23 (синоніми: перебудови гену KMT2A, перебудови гену MLL) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F047</td><td>Визначення транcлокації t(12;21) (синоніми: транслокація ETV6/RUNX1, транслокація TEL/AML1) методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОМПЛЕКСНА ПРОПОЗИЦІЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F048</td><td>Визначення транcлокації t(9;22)(транслокація BCR/ABL), перебудов 11q23(перебудови гену KMT2A, перебудови гену MLL) та транcлокації t(12;21)(транслокація ETV6/RUNX1, транслокація TEL/AML1) методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ДІАГНОСТИКА МІЄЛОДИСПЛАСТИЧНОГО СИНДРОМУ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F049</td><td>Визначення делеції хромосоми 5q (синоніми: делеція 5q31.2, -5, делеція гену EGR1) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F050</td><td>Визначення делеції хромосоми 7q (синоніми: делеція 7q31, -7) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F051</td><td>Визначення делеції хромосоми 17р (синоніми: делеція 17p13.1, делеція гену P53) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F052</td><td>Визначення кількості хромосом 8 (синонім: +8) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F053</td><td>Визначення втрати хромосоми Y (синонім: -Y) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F054</td><td>Визначення делеції хромосоми 20q (синонім: делеція 20q12) методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОМПЛЕКСНІ ПРОПОЗИЦІЇ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>F055</td><td>Визначення делеції хромосоми 5q та делеції хромосоми 7q методом FISH</td><td>7 днів</td></tr>
      <tr><td>F056</td><td>Визначення делеції хромосоми 5q, делеції хромосоми 7q та делеції хромосоми 17р (делеція гену P53) методом FISH</td><td>7 днів</td></tr>
      <tr><td>F057</td><td>Визначення делеції хромосоми 5q, делеції хромосоми 7q, делеції хромосоми 17р (делеція гену P53), кількості хромосом 8, втрати хромосоми Y та делеції хромосоми 20q методом FISH</td><td>7 днів</td></tr>
    </tbody>
  </table>
</div>

<h2 class="nomenclature-section-header">ЦИТОЛОГІЧНІ ДОСЛІДЖЕННЯ</h2>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ГІНЕКОЛОГІЧНИЙ МАТЕРІАЛ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>C001</td><td>Класичний ПАП-тест (скринінгове дослідження мазка шийки матки)</td><td>2 дні</td></tr>
      <tr><td>C002</td><td>Цитологічне дослідження аспірату з порожнини матки та відбитку ВМС</td><td>2 дні</td></tr>
      <tr><td>C004</td><td>Комплексне дослідження: класичний ПАП-тест (скринінгове дослідження мазка шийки матки) + мікроскопічний аналіз виділень із сечостатевих органів (бактеріоскопія)</td><td>3 дні</td></tr>
      <tr><td>С017</td><td>Мікроскопічний аналіз виділень із сечостатевих органів</td><td>2 дні</td></tr>
      <tr><td>С018</td><td>Кольпоцитологічне дослідження</td><td>2 дні</td></tr>
      <tr><td>С020</td><td>Рідинна цитологія ПАП-тест</td><td>2 дні</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">НЕГІНЕКОЛОГІЧНИЙ МАТЕРІАЛ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>C005</td><td>Цитологічне дослідження грудної залози (тонкоголкових пункційних біопсій, утворень та кіст, виділень із соска грудних залоз)</td><td>2 дні</td></tr>
      <tr><td>C006</td><td>Цитологічне дослідження матеріалу зішкрібу зі шкіри, слизових оболонок</td><td>2 дні</td></tr>
      <tr><td>C007</td><td>Цитологічне дослідження випітних рідин при метастатичних процесах з можливістю виготовлення цитоблоків</td><td>2 дні</td></tr>
      <tr><td>C008</td><td>Цитологічне дослідження пунктатів кістозних утворень</td><td>2 дні</td></tr>
      <tr><td>C009</td><td>Цитологічне дослідження матеріалу, взятого при бронхоскопії (промивні води, мазки, бронхоальвеолярний лаваж)</td><td>2 дні</td></tr>
      <tr><td>C010</td><td>Цитологічне дослідження тонкоголкових пункційних біопсій легень, середостіння</td><td>2 дні</td></tr>
      <tr><td>C011</td><td>Цитологічне дослідження відбитків та пунктатів лімфовузлів, слинних залоз</td><td>2 дні</td></tr>
      <tr><td>C012</td><td>Цитологічне дослідження матеріалу зі шлунково-кишкового тракту, печінки, підшлункової залози</td><td>2 дні</td></tr>
      <tr><td>C013</td><td>Цитологічне дослідження тонкоголкових пункційних біопсій м&#x27;яких тканин, суглобів і кісток</td><td>2 дні</td></tr>
      <tr><td>C014</td><td>Цитологічне дослідження сечі</td><td>2 дні</td></tr>
      <tr><td>C019</td><td>Мікроскопічний аналіз секрету простати</td><td>2 дні</td></tr>
      <tr><td>C021</td><td>Рідинна цитологія тонкоголкових пункційних біопсій (1 локалізація)</td><td>2 дні</td></tr>
      <tr><td>C023</td><td>Цитологічне дослідження тонкоголкових пункційних біопсій щитоподібної залози (до 10 скелець)</td><td>2 дні</td></tr>
      <tr><td>C024</td><td>Назоцитограма</td><td>2 дні</td></tr>
      <tr><td>C025</td><td>Демодекоз (виявлення кліщів роду Demodex на бровах, віях, у вмісті папул, епітеліальному зішкрібі)</td><td>2 дні</td></tr>
      <tr><td>C026</td><td>Керато-, тріхо- та епідермомікози (виявлення паразитарних грибків у зішкрібі шкіри, волоссі, нігтях)</td><td>2 дні</td></tr>
      <tr><td>C027</td><td>Ентеробіоз (виявлення Enterobius vermicularis у зішкрібі з перианальних складок)</td><td>2 дні</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">ЕКСПРЕС ЦИТОЛОГІЧНІ ДОСЛІДЖЕННЯ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>CED001</td><td>Інтраопераційне цитологічне дослідження</td><td>60 хвилин</td></tr>
    </tbody>
  </table>
</div>

<div class="nomenclature-section">
  <h3 class="nomenclature-category">КОНСУЛЬТАЦІЇ ЦИТОЛОГІЧНОГО МАТЕРІАЛУ</h3>
  <table class="nomenclature-table">
    <thead><tr><th>Код</th><th>Послуга</th><th>Строк</th></tr></thead>
    <tbody>
      <tr><td>C015</td><td>Консультація гінекологічного цитологічного матеріалу (друга думка/second opinion) за 1 матеріал</td><td>2 дні</td></tr>
      <tr><td>C016</td><td>Консультація негінекологічного цитологічного матеріалу  (друга думка/second opinion) за 1 матеріал</td><td>2 дні</td></tr>
    </tbody>
  </table>
</div>
`;

const TEMPLATE = `
<section class="nomenclature-cta-section container-fluid fade-up">
    <div class="row">
        <div class="col-lg-6 col-md-6">
            <p class="section-label" data-animate-child>Наші послуги</p>
        </div>
        <div class="col-lg-6 col-md-6">
            <h3 data-animate-child>Повна номенклатура досліджень</h3>
            <p data-animate-child>Патогістологічні, імуногістохімічні, цитологічні, молекулярно-генетичні та біохімічні дослідження — понад 200 позицій з термінами виконання.</p>
            <button class="nomenclature-open-btn" id="nomenclature-open-btn" data-animate-child data-delay="200">
                Переглянути номенклатуру
            </button>
        </div>
    </div>
</section>

<div class="nomenclature-modal" id="nomenclature-modal">
    <div class="nomenclature-modal-content">
        <button class="nomenclature-close-btn" id="nomenclature-close-btn" aria-label="Закрити">
                <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="42" height="42" rx="10.5" fill="#0090B8"/>
                    <rect x="11.708" y="28.8076" width="24.1818" height="2.1" rx="1.05"
                          transform="rotate(-45 11.708 28.8076)" fill="white"/>
                    <rect x="13.1929" y="11.708" width="24.1818" height="2.1" rx="1.05"
                          transform="rotate(45 13.1929 11.708)" fill="white"/>
                </svg>
            </button>
        <div class="nomenclature-modal-body">
            ${NOMENCLATURE_HTML}
        </div>
    </div>
</div>
`;

class BmlNomenclature extends HTMLElement {
    connectedCallback() {
        if (!this.innerHTML.trim()) this.innerHTML = TEMPLATE;
        this._initModal();
    }

    _initModal() {
        const modal = this.querySelector('#nomenclature-modal');
        const openBtn = this.querySelector('#nomenclature-open-btn');
        const closeBtn = this.querySelector('#nomenclature-close-btn');
        if (!modal || !openBtn) return;

        openBtn.addEventListener('click', () => {
            modal.classList.add('show');
            document.body.style.overflow = 'hidden';
        });

        const close = () => {
            modal.classList.remove('show');
            document.body.style.overflow = '';
        };

        closeBtn?.addEventListener('click', close);
        modal.addEventListener('click', e => { if (e.target === modal) close(); });
        document.addEventListener('keydown', e => {
            if (e.key === 'Escape' && modal.classList.contains('show')) close();
        });
    }
}

customElements.define('bml-nomenclature', BmlNomenclature);
